<template>
    <div v-if="status !== 'loading'">
        <direct-form
                v-if="form_data.user_found"
                :form_data="form_data"
                :direct_form_data="direct_form_data"
                :submit="submit"
                :price="price"
        ></direct-form>
        <kt-panel v-else>
            <kt-panel-body>
                <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                    {{ $t('message.payment_page_not_found') }}
                </p>
            </kt-panel-body>
        </kt-panel>
    </div>
    <loader v-else></loader>
</template>

<script>
import directForm from "./components/direct-form"
import Loading from '@/components/custom/loading'
import {mapGetters} from "vuex";
import { KTApp } from '@/plugins/core/app'
import { pardakhtShakhsiService } from '@/common/api.service'
import $ from "jquery";
import router from "../../router";
import {i18n} from "@/plugins/i18n";
import toastr from "toastr";

export default {
    name: "Direct",

    components: {
        'direct-form': directForm,
        'loader': Loading
    },
    computed: {
        ...mapGetters('pardakhtShakhsi', [
            'form_data', 'status'
        ]),
        ...mapGetters('pardakhtShakhsi', [
            'direct_form_data'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
        if (this.$route.query.e){
            this.showError()
        }

    },

    data() {
        return {
            'username': this.$route.params.username,
            price: Number(this.$route.params.price),
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('pardakhtShakhsi/directPay', vm.username)
        })
    },
    methods: {
        showError(){
            this.toastr.error(i18n.t('pardakht_shakhsi.error_numbers.'+this.$route.query.e))
        },
        submit(e) {
            let form = $('#payment_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    payer_phone_number: {
                        required: true,
                    },
                    amount: {
                        required: true,
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            let params = this.$store.getters['pardakhtShakhsi/direct_form_data']

            if (params.amount < 10000) {
                alert (i18n.t('label.minimum_value_direct_transaction_alert'))
                return
            }

            KTApp.progress(btn)

            pardakhtShakhsiService.newDirectPay(params).then(response => {
                this.$router.push({
                    name: 'direct_checkout',
                    params: {
                        tracking_code: response.data.data.tracking_number
                    }
                });
            })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
    },
}
</script>

<style scoped>

</style>